export const GUARDIAN_STUDENT_SELECT = 'GUARDIAN_STUDENT_SELECT'
export const SET_GUARDIAN_USER = 'SET_GUARDIAN_USER'

export const guardianStudentSelect = student => ({
  type: GUARDIAN_STUDENT_SELECT,
  payload: student
})

export const setGuardianUser = guardian => ({
  type: SET_GUARDIAN_USER,
  payload: guardian
})
